<template>
  <div id="ecommerce-checkout-demo">
    <form-wizard ref="checkoutWizard" color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null"
      :hide-buttons="true">

      <!-- tab 1 content -->
      <tab-content title="Carrito" icon="feather icon-shopping-cart" class="mb-5">

        <!-- IF CART HAVE ITEMS -->
        <div class="vx-row" v-if="cartItems.length">

          <!-- LEFT COL -->
          <div class="vx-col lg:w-2/3 w-full relative">
            <div class="items-list-view" v-for="(item, index) in cartItems"
              :key="item.objectID+''+item.student.id_usuario_estudiante">
              <item-list-view :item="item" :statusPreventa="statusPreventa">

                <!-- SLOT: ITEM META -->
                <template slot="item-meta">
                  <h6 class="item-name font-semibold mb-1">{{ item.name }}</h6>
                  <br>
                  <div class="badge badge-primary badge-md" v-if="(item.aplica_descuento == 'S' || item.aplica_descuento == true || item.aplica_descuento =='true') && statusPreventa">
                     <i class="feather icon-star"> Aplica descuento {{porcentajeDescuento}} % </i>
                  </div>
                  <div class="p-1 flex justify-between mb-2">
                    <span class="text-success" style="font-weight: 500;">{{ item.student.nombre_completos }}
                    </span>
                  </div>
                  <!--p class="text-sm mb-2 cursor-pointer">By <span class="text-primary font-semibold">{{ item.brand }}</span></p-->
                  <p class="text-success text-sm" v-if="!statusPreventa">En stock {{parseInt(item.stock)}}</p>

                  <p class="mt-4 font-bold text-sm">Cantidad</p>
                    <!--v-bind:max="item.stock"-->
                  <template v-if="statusPreventa">
                      <vs-input-number v-show="statusPreventa" v-bind:min="parseInt(item.cantidad)" v-bind:max="(((item.tipo_producto === tipo_transporte && item.cod_producto === parseInt(id_transporte)) == true) ? item.stock : 999)"
                        :value="parseInt(item.quantity)"
                        @input="updateItemQuantity($event, index)" class="inline-flex" />
                  </template>
                  <template v-else>
                      <vs-input-number v-bind:min="1"  v-bind:max="parseInt(item.stock)" :value="parseInt(item.quantity)"
                       @input="updateItemQuantity($event, index)" class="inline-flex" />
                  </template>
                  <!--p class="font-medium text-grey mt-4">Delivery by, {{ item.delivery_date }}</p-->
                  <!--p class="text-success font-medium">{{ item.discount_in_percentage }}% off {{ item.offers_count }} offers Available</p-->
                </template>

                <!-- SLOT: ACTION BUTTONS -->
                <template slot="action-buttons" v-if="!(item.isProductPreventa && statusPreventa)">
                  <!-- PRIMARY BUTTON: REMOVE -->
                  <div 
                    class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3"
                    @click="((item.isProductPreventa == true && statusPreventa) ? null : removeItemFromCart(item))" >
                    <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
                    <span class="text-sm font-semibold ml-2">Descartar</span>
                  </div>
                </template>
              </item-list-view>
            </div>
          </div>

          <!-- RIGHT COL -->
          <div class="vx-col lg:w-1/3 w-full">
            <vx-card>
              <p class="font-semibold mb-3">Detalle de Factura</p>
              <div class="flex justify-between mb-2">
                <span class="text-grey" v-text="'SubTotal '+labelIva+' %'"></span>
                <span>
                  <span>
                      {{'$'+(_.round(subTotalConIva,4)).toFixed(4)}}
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">SubTotal 0%</span>
                <span>
                  <span>
                        {{'$'+(_.round(subTotalSinIva,4)).toFixed(4)}}
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey" v-text="'Impuesto '+labelIva+' %'"></span>
                <span class="text-success">
                  <span>
                      {{'$'+(_.round(impuesto,4)).toFixed(4)}}
                  </span>
                </span>
              </div>
              <vs-divider />

              <div class="flex justify-between font-semibold mb-3">
                <span>Total</span>
                <span class="text-success">
                  <b> <span>
                      {{'$'+(_.round(total,4)).toFixed(2)}}
                    </span></b>
                </span>
              </div>
                <vs-button class="w-full" :disabled="statusListaCompleta" @click="($refs.checkoutWizard.nextTab()),(cargaGeneral())">REALIZAR COMPRA</vs-button>
            </vx-card>
          </div>
        </div>

        <!-- IF NO ITEMS IN CART -->
        <vx-card title="Usted no tiene ningun producto en el carrito." v-else>
          <vs-button @click="$router.push('/dashboard/ecommerce').catch(() => {})">Ir Tienda</vs-button>
        </vx-card>

      </tab-content>

      <!-- tab 2 content -->
      <tab-content title="Dirección" icon="feather icon-home" class="mb-5" :beforeChange="puedeIrPestanaPago">

        <div class="vx-row">

          <!-- LEFT COL: NEW ADDRESS -->
          <div class="vx-col lg:w-2/3 w-full">
            <vx-card title="Dirección" subtitle="Asegurece de &quot;seleccionar una dirección&quot;" class="mb-base">
              <div class="vx-col sm:w-3/4 w-full mb-2">
                <div class="search-results" style="width:100% !important;">
                  <v-select placeholder="Seleccione un tipo de Entrega" v-model="selectTipoEntrega" label="descripcion"
                    :options="listaTipoEntrega" :dir="$vs.rtl ? 'rtl' : 'ltr'" @click="computadaTipoEntrega" />
                  <br>
                </div>
                <div class="search-results" style="width:100% !important;" v-show="computadaTipoEntrega">
                  <v-select placeholder="Listado de direcciones" v-model="selectDireccion" label="direccion"
                    :options="listaDirecciones" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-on:input="computadaDireccion" />
                  <br>
                </div>
              </div>
              <!--Seccion de retiro ipac-->
              <div v-show="esRetiraInstitucion">
                <div class="vx-col sm:w-2/2 w-full mb-2">
                    <vs-input
                      v-validate="'required|alpha_spaces|min:3'"
                      label-placeholder="Contacto*" 
                      name="nombreRetira" 
                      data-vv-as="Contacto" 
                      v-model="formRetiraInst.nombre"
                      class=" w-full  mt-6" 
                      data-vv-scope="info-retiro-inst" 
                      @blur="limpiarEspacios('nombre')"/>
                    <span class="text-danger text-sm">{{ errors.first('info-retiro-inst.nombreRetira') }}</span>
                  </div>
                <div class="vx-col sm:w-1/4 w-full mb-2">
                    <vs-input
                      v-validate="esRetiraInstitucion ? { required: true, regex: /^\+?[0-9-]{7,20}$/ } : ''"
                      label-placeholder="Celular*"
                      name="celular"
                      data-vv-as="Celular"
                      v-model="formRetiraInst.celular"
                      class="w-full mt-6"
                      data-vv-scope="info-retiro-inst"
                      @input="formRetiraInst.celular = formRetiraInst.celular.replace(/\s+/g, '')"
                    />
                    <span class="text-danger text-sm">{{ errors.first('info-retiro-inst.celular') }}</span>
                </div>
              </div>
               <!--Seccion de mis direcciones-->
              <div class="vx-col sm:w-1/4 w-full mb-2 " v-show="computadaTipoEntrega">
                <div class="search-results" style="width:100% !important;">
                  <vs-button  data-toggle="tooltip" data-placement="bottom" title="Habilitar y Deshabilitar creación dirección" data-original-title="Habilitar y Deshabilitar creación dirección" @click="habilitarDireccion" size="small" color="success" class="mt-3"><i class="material-icons">add</i></vs-button>
                </div>
              </div>
              <form data-vv-scope="add-new-address" v-show="computadaTipoEntrega">
                <div class="vx-row">
                  <div class="vx-col sm:w-2/2 w-full mb-2">
                    <vs-input :disabled="estado_direccion" v-validate="'required|min:3'" data-vv-validate-on="blur"
                      label-placeholder="direccion" name="direccion" placeholder="Dirección*" v-model="direccion"
                      class=" w-full  mt-6" />
                    <span class="text-danger text-sm">{{ errors.first('direccion') }}</span>
                  </div>
                  <div class="vx-col sm:w-2/2 w-full mb-2">
                    <vs-input :disabled="estado_referencia" data-vv-validate-on="blur" label-placeholder="referencia"
                      name="referencia" placeholder="Referencia" v-model="referencia" class="  w-full mt-6" />
                  </div>
                  <div class="vx-col sm:w-1/4 w-full mb-2">
                    <v-select :disabled="estado_pais" placeholder="Seleccione un País*" label="descripcion" key="valor" :options="selects.paises" v-on:input="changePais" v-model="pais"></v-select>
                    <span class="text-danger text-sm">{{ errors.first('pais') }}</span>
                  </div>
                  <div class="vx-col sm:w-1/4 w-full mb-2">
                    <v-select :disabled="estado_provincia"  placeholder="Seleccione un Provincia*" label="descripcion" key="valor" :options="selects.provincias" v-on:input="changeProvincia" v-model="provincia"></v-select>
                    <span class="text-danger text-sm">{{ errors.first('provincia') }}</span>
                  </div>
                  <div class="vx-col sm:w-1/4 w-full mb-2">
                    <v-select :disabled="estado_canton"  placeholder="Seleccione un Cantón*" label="descripcion" key="valor" :options="selects.ciudades" v-on:input="changeCiudad" v-model="canton"></v-select>
                    <span class="text-danger text-sm">{{ errors.first('canton') }}</span>
                  </div>
                  <div class="vx-col sm:w-1/4 w-full mb-2">
                    <v-select :disabled="estado_parroquia" placeholder="Seleccione un Parroquía*" label="descripcion" key="valor" :options="selects.barrios" v-model="parroquia"></v-select>
                  </div>

                  <div class="vx-col sm:w-1/4 w-full mb-2">
                    <vs-input :disabled="estado_celular" data-vv-validate-on="blur" label-placeholder="celular"
                      name="celular" placeholder="Celular" v-model="celular" class=" w-full  mt-6" />
                    <span class="text-danger text-sm"> </span>
                  </div>
                  <div class="vx-col sm:w-2/2 w-full mb-2" >
                      <vs-button class="float-right mt-6" style="float:left !important;" @click="insertarActualizar" :disabled="!validateForm">
                          <template v-if="selectDireccion != null ">
                            Actualizar Información Dirección
                          </template>
                          <template v-else>
                            Guardar Dirección
                          </template>
                      </vs-button>
                  </div>
                  <div class="vx-col sm:w-2/2 w-full mb-2" >
                    <span class="text-danger text-sm" sytle=" font-size: 15px !important;   font-weight: 600;">Si ha modificado la dirección por favor dar click en "Actualizar Información Dirección".</span>
                  </div>
                </div>
              </form>
              <!-- {{-- ($refs.checkoutWizard.nextTab()),(cargaGeneralCliente()) --}} -->
              <vs-button  class="mt-6 ml-auto flex" :disabled="statusTabDireccion" @click="(cargaGeneralCliente())">SIGUIENTE</vs-button>
              <!--vs-button class="mt-6 ml-auto flex" @click.prevent="submitNewAddressForm">SIGUIENTE</vs-button-->
              <span class="text-danger text-sm" sytle=" font-size: 15px !important;   font-weight: 600;">Recordamos que los envió se realizan a la provincia del guayas.</span>
            </vx-card>
          </div>

          <!-- RIGHT COL: CONTINUE WITH SAVED ADDRESS -->
          <div class="vx-col lg:w-1/3 w-full">
            <vx-card title="Detalle envío">
              <div>
                <div class="flex justify-between mb-2">
                  <span class="text-grey">Pais: </span>
                  <span style="text-align:end;">
                    <span v-text="pais.descripcion">
                    </span>
                  </span>
                </div>
                <div class="flex justify-between mb-2">
                  <span class="text-grey">Provincia:</span>
                  <span style="text-align:end;">
                    <span v-text="provincia.descripcion">
                    </span>
                  </span>
                </div>
                <div class="flex justify-between mb-2">
                  <span class="text-grey">Parroquia:</span>
                  <span style="text-align:end;">
                    <span v-text="parroquia.descripcion">
                    </span>
                  </span>
                </div>
                <div class="flex justify-between mb-2">
                  <span class="text-grey">Canton:</span>
                  <span style="text-align:end;">
                    <span v-text="canton.descripcion">
                    </span>
                  </span>
                </div>
                <div class="flex justify-between mb-2">
                  <span class="text-grey">Direccion:</span>
                  <span style="text-align:end;">
                    <span v-text="direccion">
                    </span>
                  </span>
                </div>
                <div class="flex justify-between mb-2">
                  <span class="text-grey">Referencia:</span>
                  <span style="text-align:end;">
                    <span v-text="referencia">
                    </span>
                  </span>
                </div>
                <div class="flex justify-between mb-2">
                  <span class="text-grey">Telefono:</span>
                  <span style="text-align:end;">
                    <span v-text="telefono">
                    </span>
                  </span>
                </div>
                <div class="flex justify-between mb-2">
                  <span class="text-grey">Celular:</span>
                  <span style="text-align:end;">
                    <span v-text="celular">
                    </span>
                  </span>
                </div>
              </div>
              <vs-divider />

       
              <p class="font-semibold mb-3">Detalle de Factura</p>
              <div class="flex justify-between mb-2">
                <span class="text-grey" v-text="'SubTotal '+labelIva+' %'"></span>
                <span>
                  <span v-text="'$'+subTotalConIva.toFixed(4)">
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">SubTotal 0%</span>
                <span>
                  <span v-text="'$'+subTotalSinIva.toFixed(4)">
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey" v-text="'Impuesto '+labelIva+' %'"></span>
                <span class="text-success">$
                  <span v-text="impuesto.toFixed(4)">
                  </span>
                </span>
              </div>
              <vs-divider />

              <div class="flex justify-between font-semibold mb-3">
                <span>Total</span>
                <span class="text-success"> $
                  <b> <span v-text="total.toFixed(2)">
                    </span></b>
                </span>
              </div>
            </vx-card>
          </div>
        </div>
      </tab-content>

      <!-- tab 3 content -->
      <tab-content title="Forma de Pago" icon="feather icon-credit-card" class="mb-5">

        <div class="vx-row">

          <!-- LEFT COL: PAYMENT OPTIONS -->
          <div class="vx-col lg:w-2/3 w-full">
            <vx-card title="DATOS FACTURA " subtitle="" class="mb-base">
              <form data-vv-scope="add-new-address">
                <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <div slot="header">
                    <h3>
                      Datos de Facturación
                    </h3>
                  </div>
                  <div class="vx-row mb-8 mt-1 pt-1">
                    <div class="vx-col sm:w-1/2 w-full">
                      <vs-select label="Tipo Pago *: " v-model="selectFacturaPago" class="w-full">
                        <vs-select-item :key="index" :value="item" :text="item.text"
                          v-for="(item,index) in facturaTipoPago" />
                      </vs-select>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full" v-if="(selectFacturaPago == null ? false : selectFacturaPago.value == 2 ? true : false)">
                        <div class="pt-1 bg-white vx-col w-full flex items-center justify-center" style="height: 50px !important; ">
                            <img class="responsive card-img-top" style="height: 80px !important ; width:150px !important" v-bind:src="require('@/assets/images/card-credit/dinersClub.png')"/>
                            <img class="responsive card-img-top" style="height: 50px !important ; width:50px !important" v-bind:src="require('@/assets/images/card-credit/visa.png')"/>
                        </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-full mb-2">
                      <div class="search-results" style="width:100% !important;">
                        <v-select placeholder="Listado de clientes" v-model="selectCliente" label="nombres_completos"
                          :options="listaClientes" :dir="$vs.rtl ? 'rtl' : 'ltr'" @click="computadaCliente" />
                        <br>
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col sm:w-2/4 mb-2">
                      <vs-input :disabled="estado_numero_identificacion" type="number" label-placeholder="Name"
                        name="numero_identificacion" placeholder="Cédula de Identidad*" v-model="numero_identificacion"
                        class=" w-full  mt-6" />
                      <span class="text-danger text-sm">{{ errors.first('numero_identificacion') }}</span>
                    </div>
                    <div class="vx-col sm:w-2/4">
                      <vs-button data-toggle="tooltip" data-placement="bottom" title="Buscar cliente" data-original-title="Buscar cliente"  @click="searchIdentificationNumber" size="small" color="success" class="mt-3"><i
                          class="material-icons">search</i></vs-button>
                      <vs-button data-toggle="tooltip" data-placement="bottom" title="Limpiar formulario" data-original-title="Limpiar formulario"  @click="clearFormCliente" size="small" color="warning" class="ml-6 mt-3"><i
                          class="material-icons">clear_all</i></vs-button>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                      <vs-input :disabled="estado_email" v-validate="'required|email'" data-vv-validate-on="blur"
                        name="email" type="email" label-placeholder="Email" placeholder="Email*" v-model="email"
                        class="w-full  mt-6" />
                      <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                    </div>
                    <div class="vx-col  sm:w-1/2 w-full mb-5">
                      <vs-input :disabled="estado_nombres" v-validate="'required|min:3'" data-vv-validate-on="blur"
                        label-placeholder="Nombre" name="nombres_cliente" placeholder="Nombres*"
                        v-model="nombres_cliente" class=" w-full  mt-6" />
                      <span class="text-danger text-sm">{{ errors.first('nombres_cliente') }}</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                      <vs-input :disabled="estado_apellidos" v-validate="'required|min:3'" label-placeholder="apellidos"
                        name="apellidos" placeholder="Apellidos*" v-model="apellidos" class="w-full   mt-6" />
                      <span class="text-danger text-sm">{{ errors.first('apellidos') }}</span>
                    </div>
                    <div class="vx-col sm:w-1/4 w-full mb-2">
                      <vs-input :disabled="estado_telefonoCliente" data-vv-validate-on="blur"
                        label-placeholder="telefonoCliente" name="telefonoCliente" placeholder="Telefono"
                        v-model="telefonoCliente" class=" w-full mt-6" />
                      <span class="text-danger text-sm"></span>
                    </div>

                    <div class="vx-col sm:w-1/4 w-full mb-2">
                      <vs-input :disabled="estado_celularCliente" data-vv-validate-on="blur"
                        label-placeholder="celularCliente" name="celularCliente" placeholder="Celular"
                        v-model="celularCliente" class=" w-full  mt-6" />
                      <span class="text-danger text-sm"> </span>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                      <vs-button class="float-left mt-6" @click="insertarActualizarCliente"
                        :disabled="!validateFormCliente">
                          <template v-if="selectCliente != null ">
                            Actualizar Información Cliente
                          </template>
                          <template v-else>
                            Guardar Cliente
                          </template>
                      </vs-button>
                    </div>
                  </div>
                </vs-col>
                <div class="p-4 pl-0 pb-2 flex flex-col text-left">
                    <div class="flex justify-left font-semibold mb-3">
                      <span>Total a pagar:</span>
                      <span class="text-success ml-2"> $
                        <b> <span>{{(_.round(total,2)).toFixed(2)}}
                          </span></b>
                      </span>
                    </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col mt-3 mr-0 pr-0">
                    <vs-checkbox id="obligatorio" v-model="aceptoTerminoCondiciones"/>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-2 ml-0">
                    <span> He aceptado y leído los </span>
                    <vs-button class="ml-0 pl-0 pr-0 mr-0" color="primary" type="flat"  @click="popupTerminosCondiciones = true">términos y condiciones</vs-button>
                  </div>
                </div>
                <div class="flex flex-wrap justify-center mb-3">
                  <!-- <vs-button  class="mt-6 ml-auto flex js-paymentez-checkout"  :disabled="(statusTabFactura || statusTabDireccion)" color="primary" @click="abrirBotonPago()">Botón de pago</vs-button> -->
                  <vs-button class="mt-6 ml-auto flex" :disabled="(statusTabFactura || statusTabDireccion)" @click.prevent="manejadorGenerarComprobante('')">REALIZAR COMPRA</vs-button>
                </div>
                <span class="text-danger text-sm" sytle="    font-weight: 600;   font-size: 15px !important;" v-show="statusTabDireccion">Seleccione una dirección.</span> <br>
					      <span class="text-danger text-sm" sytle=" font-size: 15px !important;   font-weight: 600;" v-show="statusTabFactura">Seleccione un cliente, una forma de pago y acepte los términos y condiciones.</span>
              </form>
            </vx-card>
          </div>

          <!-- RIGHT COL: PRICE -->
          <div class="vx-col lg:w-1/3 w-full">
            <vx-card title="Detalle de factura">
              <p class="font-semibold mb-3">Datos Factura</p>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Facturado a:</span>
                <span style="text-align:end;">
                  <span v-text="nombres_cliente+'  '+apellidos">
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Cédula / RUC:</span>
                <span style="text-align:end;">
                  <span v-text="numero_identificacion">
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Tipo Pago:</span>
                <span style="text-align:end;">
                  <span v-text="selectFacturaPago.text">
                  </span>
                </span>
              </div>
              <vs-divider />
              <p class="font-semibold mb-3">Datos Dirección</p>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Número telefonico:</span>
                <span style="text-align:end;">
                  <span v-text="telefono">
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Dirección:</span>
                <span style="text-align:end;">
                  <span v-text="direccion">
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Referencia:</span>
                <span style="text-align:end;">
                  <span v-text="referencia">
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Ciudad:</span>
                <span style="text-align:end;">
                  <span v-text="direccion">
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Provincia:</span>
                <span style="text-align:end;">
                  <span v-text="provincia.descripcion">
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Tipo Entrega:</span>
                <span style="text-align:end;">
                  <span v-text="(selectTipoEntrega == null) ? null : selectTipoEntrega.descripcion">
                  </span>
                </span>
              </div>
              <vs-divider />

              <p class="font-semibold mb-3">Detalle de Factura</p>
              <div class="flex justify-between mb-2">
                <span class="text-grey" v-text="'SubTotal '+labelIva+' %'"></span>
                <span>
                  <span>
                      {{'$'+(_.round(subTotalConIva,4)).toFixed(4)}}
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">SubTotal 0%</span>
                <span>
                  <span>
                    {{'$'+(_.round(subTotalSinIva,4)).toFixed(4)}}
                  </span>
                </span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey" v-text="'Impuesto '+labelIva+' %'"></span>
                <span class="text-success">
                  <span>
                        {{'$'+(_.round(impuesto,4)).toFixed(4)}}
                  </span>
                </span>
              </div>
              <vs-divider />

              <div class="flex justify-between font-semibold mb-3">
                <span>Total</span>
                <span class="text-success"> $
                  <b> <span>{{(_.round(total,2)).toFixed(2)}}
                    </span></b>
                </span>
              </div>
            </vx-card>
          </div>
        </div>
      </tab-content>

    </form-wizard>
    <label v-text="validatePreventaListComplet"></label>
    <vs-popup class="holamundo" v-bind:title="'Mapgrafi informa'" :active.sync="popupCorrectOrder">
        <p>{{ mensaje }} <b> </b>
            <br>
        </p>
        <div class="flex flex-wrap justify-center mb-3">
            <vs-button  color="success"  @click="(popupCorrectOrder = !popupCorrectOrder)">Aceptar</vs-button>
        </div>
    </vs-popup>
    <vs-popup class="holamundo" v-bind:title="'Mapgrafi informa'" :active.sync="popupCorrectOrderCompra" >
        <p>{{ mensaje }} <b> </b>
            <br>
        </p>
        <div v-html="mensajeLeyenda">
        </div>
        <div class="flex flex-wrap justify-center mb-3">
            <vs-button  color="success"  @click="(popupCorrectOrderCompra = !popupCorrectOrderCompra)">Aceptar</vs-button>
        </div>
    </vs-popup>
     <vs-popup class="holamundo" v-bind:title="'Mapgrafi informa'" :active.sync="popupErrorOrder">
        <p>Tenemos un problema, vuelva a cargar el sitio web.<b> </b>
            <br>
        </p>
        <div class="flex flex-wrap justify-center mb-3">
            <vs-button  color="danger"  @click="(popupErrorOrder = !popupErrorOrder)">Salir</vs-button>
        </div>
    </vs-popup>
    <vs-popup id="terminos_condiciones" v-bind:title="'Mapgrafi informa'" :active.sync="popupTerminosCondiciones">
        <div class="p-4 flex flex-col w-full text-center">
            <p class="messagePerfect" style="font-weight: 900;">Términos y condiciones</p>
        </div>
        <vs-textarea v-html="'<b>Política de Envío: </b> <br> Tiempo de entrega 5 a 7 días hábiles dependiendo la zona del país a través de transporte. Los días de entregas depende la zona del país en horarios laborales de lunes a viernes. <br> <b>Cancelación: </b><br>         Las cancelaciones de compra se realizarán dentro de las 24 horas de realizar el pedido sin cargo alguno. Al realizar la cancelación MAPGRAFI verificará que el tiempo sea menor a 24 horas, devolverá el dinero una vez realizado el pago por el emisor de la tarjeta de crédito o en caso de transferencia una vez confirmada la misma,  y el envío logístico se cancelará. Para más información ponerse en contacto con el “Servicio de atención al cliente” llamando al 042837629 <br> <b>Devolución: </b><br>  Todos los pedidos están incluidos en la política de devolución, esto significa que dispondrás de hasta 4 días para decidir si quieres quedarte con el producto o devolverlo. Se aceptan devoluciones siempre que el producto no haya sido abierto y venga en su embalaje original. Las devoluciones serán realizadas en el local de Mappgrafi, donde se verificará el estado del producto y de darse caso se realizará una nota de crédito sobre la compra, para después realizar la transferencia bancaria por el valor resultante.           Independientemente del derecho de desistimiento descrito anteriormente, la política de devolución de MAPGRAFI te permite devolver los productos en caso de que no quedes satisfecho con tu compra hasta 4 días desde la fecha de recepción del producto. Los productos deben ser devueltos en el mismo estado en el que los recibiste. Por lo tanto, los productos nuevos deben ser devueltos nuevos, sin usar y completos. <br> Esta política de devoluciones no afecta a tus derechos legales de cliente. <br> Productos defectuosos o dañados. Nuestro Centro de Soporte de Devoluciones solo puede utilizarse de forma limitada para quejas realizadas después de 30 días de la fecha de recepción. Ponte en contacto con nuestro nuestro Servicio de Atención al Cliente para que podamos ayudarte a ejercer tu derecho de garantía. Producto dañado durante el envío. Si recibes un producto dañado durante su envío, ponte en contacto con nuestros Servicio de Atención al Cliente para devolverlo en un plazo de 30 días a partir de la fecha de recepción del pedido.  Para devolver productos debes comunicarte puedes cambiarlo en un plazo no mayor a 15 días desde que lo recibiste. Para devolverlo solo tienes que ponerte en contacto con el “Servicio de atención al cliente”  <br> Privacidad, la compañía MAPGRAFI se reserva el uso de la información, los datos del tarjetahabiente quedarán privados y seguros en el api de pagos. MAPGRAFI guardará para constancia el número de tarjeta nombre del tarjetahabiente, tipo de tarjeta y el valor pagado. '" 
          height="100%" />
        <div class="flex flex-wrap justify-center mb-3">
            <vs-button  color="danger"  @click="(popupTerminosCondiciones = !popupTerminosCondiciones)">Salir</vs-button>
        </div>
    </vs-popup>
    <input type="hidden" v-model="manejadorSelectDireccion" />
  </div>
</template>

<script>
  import { FormWizard, TabContent } from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  const ItemListView = () => import('./components/ItemListView.vue')
  import { v4 as uuidv4 } from 'uuid';

  export default {

    data() {
      return {
        paymentCheckout: this.initPasarelaPago(),
        order_reference:null,
        pasarela: null,
        responseBoton:"",
        authorization_code:"",
        transaction_id:"",
        aceptoTerminoCondiciones:false,
        statusListaCompleta:false,
        popupCorrectOrderCompra:false,
        fecha_actual:'',
        mensaje : '',
        mensajeLeyenda:'',
        popupTerminosCondiciones:false,
        popupCorrectOrder:false,
        popupErrorOrder:false,
        valueTipoEntrega: true,
        selectTipoEntrega: null,
        porcentajeDescuento: (localStorage.discount_post),
        //TAB 2
        listaDirecciones: [],
        estado_telefono: true,
        estado_celular: true,
        estado_direccion: true,
        estado_referencia: true,
        estado_pais: true,
        estado_provincia: true,
        estado_canton: true,
        estado_parroquia: true,
        telefono: '',
        celular: '',
        direccion: '',
        referencia: '',
        cod_persona: '',
        id_direccion: '',
        id_usuario: '',
        selectDireccion: null,
        nombres: "",
        // TAB 2
        // TAB 3 - DATOS DE CLIENTES
        listaClientes: [],
        selectCliente: null,
        estado_numero_identificacion: false,
        estado_nombres: true,
        estado_apellidos: true,
        estado_email: true,
        estado_telefonoCliente: true,
        estado_celularCliente: true,
        email: '',
        nombres_cliente: '',
        apellidos: '',
        numero_identificacion: '',
        telefonoCliente: '',
        celularCliente: '',
        cod_persona: '',
        id_usuario_cliente: null,
        cod_cliente: null,

        // TAB 3 - FIN DE DATOS DE CLIENTES
        // TAB 3
        selectFacturaPago: '',
        facturaTipoPago: [{
            text: 'Depósito/Transferencia',
            value: 1
          },
          {
            text: 'Paymentez (corriente)',
            value: 2
          },
          {
            text: 'Paymentez (diferido con intereses)',
            value: 3
          },
        ],
        facturaNumDocumento: "",
        facturaNombres: "",
        paymentMethod: "debit-card",
        cvv: '',
        pais:{descripcion:'Ecuador',valor:'1'},
        provincia:{descripcion:'',valor:''},
        canton:{descripcion:'',valor:''},
        parroquia:{descripcion:'',valor:''},
        form:{
          nombre:"",
          id_pais:"",
          id_provincia:"",
          id_ciudad:"",
          id_barrio:"",
        },
        states:{},
        selects:{
          paises: [],
          provincias:[],
          ciudades:[],
          barrios:[]
        },
        data_general:{
          listadoSubTotalSinIva:[],
          listadoSubTotalConIva:[],
          listadoIva:[],
          listadoTotal:[]
        },
        formRetiraInst:{
          celular: null,
          nombre:null,
        },
      }
    },
    computed: {
      manejadorSelectDireccion(){
        var direccionTipoEntrega = this.selectTipoEntrega
        this.incluirTransporte(this.esEntregaDomicilio());
        if(direccionTipoEntrega != null){
          if(direccionTipoEntrega.id_tipo_direccion == 2) {
              var  transporte =   JSON.parse(localStorage.getItem('transporte'));
              var carItem = this.$store.state.eCommerce.cartItems.slice().reverse();
              carItem = _.groupBy(carItem,'id_estudiante');
              var _this = this;
              _.forEach(carItem, function (item,key ) {
                // if(_.size(item) == 1){
                //     _this.$store.dispatch('eCommerce/toggleItemInCart', item[0])
                //   // _this.removeItemFromCart(item[0])
                // }
                var transporteExistente = _.find(item, function(o) { return o.cod_clasificacion == transporte.cod_clasificacion &&  o.cod_fabrica == transporte.cod_fabrica; });
                if(_.isEmpty(transporteExistente)){
                  transporte.id_estudiante = item[0].student.id_estudiante;
                  transporte.student = _.clone(item[0].student);
                  _this.$store.dispatch('eCommerce/additemInCart', transporte)
                }
              });
          }
          else {
            var  transporte =   JSON.parse(localStorage.getItem('transporte'));
            var carItem = this.$store.state.eCommerce.cartItems.slice().reverse();
            carItem = _.groupBy(carItem,'id_estudiante');
            var _this = this;
            _.forEach(carItem, function (item,key ) {
                var transporteExistente = _.find(item, function(o) { return o.cod_clasificacion == transporte.cod_clasificacion &&  o.cod_fabrica == transporte.cod_fabrica; });
                if(transporteExistente != null){
                  _this.removeItemFromCart(transporteExistente)
                }
            });
          }
        }
        else {
          var  transporte =   JSON.parse(localStorage.getItem('transporte'));
          var carItem = this.$store.state.eCommerce.cartItems.slice().reverse();
          carItem = _.groupBy(carItem,'id_estudiante');
          var _this = this;
          _.forEach(carItem, function (item,key ) {
              var transporteExistente = _.find(item, function(o) { return o.cod_clasificacion == transporte.cod_clasificacion &&  o.cod_fabrica == transporte.cod_fabrica; });
              if(transporteExistente != null){
                _this.removeItemFromCart(transporteExistente)
              }
          });
        }
      },
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      },
      statusPreventa(){
        if(!_.isEmpty(localStorage.getItem('statusPreventa')))
          return  JSON.parse(localStorage.getItem('statusPreventa'));
        else{
          return false;
        }
      },
      statusTabDireccion(){
          if((this.statusPreventa) ? (this.selectTipoEntrega == null ? true : (this.selectDireccion == null ? true : false )) : (this.selectTipoEntrega == null ? true : false)) return true;
          else return false;
                
      },
      statusTabFactura(){
        if((!this.aceptoTerminoCondiciones) || (this.selectCliente == null ? true : false) || ((this.selectFacturaPago == null || this.selectFacturaPago == '') ? true : false) || (_.size(this.$store.state.eCommerce.cartItems.slice().reverse()) == 0)) return true;
        else false;
      },
      validatePreventaListComplet(){
        if(this.statusPreventa && _.size(this.$store.state.eCommerce.cartItems.slice().reverse())>0 ){
          var carItem = this.$store.state.eCommerce.cartItems.slice().reverse();
          var listaEstudiantes  = Object.keys(_.groupBy(carItem,'student.numero_identificacion'));
          var listaDevolver = [];
          var _this = this;
          this.$vs.loading();

          var listaCompletaEstudiantes = new Promise((resolve,reject) =>{
            var respuestasListaCompleta =[];
                _.forEach(listaEstudiantes,(estudiante)=>{
                  respuestasListaCompleta.push(
                    axios.post(_this.$store.state.domain+`mapgrafi/estudiante/lista-completa-carga-general`,{
                      numero_identificacion  : estudiante,
                      cod_bodega: null,
                      cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
                      cod_empresa_aca:process.env.VUE_APP_COD_EMPRESA_ACADEMICO
                    }).then((response)=>{
                      try{
                        _.forEach(response.data.data,(producto)=>{
                          producto.numero_identificacion = estudiante;
                        })
                        listaDevolver.push(response.data);
                      }catch(error){
                         reject(error);
                      }
                    }).catch((error)=>{
                      reject(error);
                    })
                  )
                });
                return Promise.all(respuestasListaCompleta).then((b)=>{
                      resolve(listaDevolver);
                }).catch((error)=>{
                  reject(error);
                });
          });

          listaCompletaEstudiantes.then((response)=>{
            try{
              if(response.existeError) throw  (_.size(listaEstudiantes) == 1)  ?  'Debe estar matriculado el estudiante.' :  'Deben estar matriculados los estudiantes.';// 'No se pudo cargar la lista completa';
                if(_.size(response.data) == 0)  throw (_.size(listaEstudiantes) == 1)  ?  'Debe estar matriculado el estudiante.' :  'Deben estar matriculados los estudiantes.';// 'No se pudo cargar la lista completa, sin datos';
                _.forEach(carItem,(itemCarrito)=>{
                  var existeProducto = 0;
                    _.forEach(response,(itemListaCompletaEstudiante)=>{
                      _.forEach(itemListaCompletaEstudiante.data[0],(productoLista)=>{
                        if(productoLista.cod_producto == itemCarrito.cod_producto  ){
                          existeProducto ++;
                        }
                      });
                    });
                    if(existeProducto == 0) throw 'Debe seleccionar toda la lista completa';
                    else{

                    }
                });
              // this.mensaje = 'TODO CORRECTO, se verifico que lleva todos los productos.';
              // this.popupCorrectOrder = true;
              this.statusListaCompleta  = false;
              this.$vs.loading.close();
            }
            catch(error){
              this.$vs.loading.close();
              this.mensaje = error;
              this.statusListaCompleta  = true;
              this.popupCorrectOrder = true;
              // this.mensaje = error;
              // this.popupCorrectOrder  = true;
            }
                        
          });
        }
      },
      id_transporte(){
        var id_transporte  = JSON.parse(localStorage.getItem('id_transporte'));
        return id_transporte;
      },
      tipo_transporte(){
        var tipo_transporte   =  JSON.parse(localStorage.getItem('tipo_transporte'));
        return tipo_transporte;
      },
      labelIva(){
        var iva = localStorage.getItem("iva");
        return iva;
      },
      leyenda_preventa(){
        var leyenda_preventa = JSON.parse(localStorage.getItem("leyenda_preventa"));
         return leyenda_preventa;
      },
      leyenda_sin_preventa(){
        var leyenda_sin_preventa = JSON.parse(localStorage.getItem("leyenda_sin_preventa"));
         return leyenda_sin_preventa;
      },
      listaTipoEntrega(){

        // const direccionesEntregaMap  = _.clone(JSON.parse(localStorage.getItem("list_direcciones")))
        const x =  JSON.parse(localStorage.getItem("list_direcciones"))
        const tipoEntrega       = JSON.parse(localStorage.getItem("tipoEntrega"))
        // let _this             = this

        if ( tipoEntrega == 'D') {
          return x.filter(value => value.id_tipo_direccion == '2'  && !this.statusPreventa)
        }
        else if(tipoEntrega == 'L'){
          return x.filter(value => value.id_tipo_direccion == '1'  && !this.statusPreventa)
        }
        else  {
          return x
        }
        // console.log("el valor de ex es ", x)


        // let listaDirecciones  = _.clone(JSON.parse(localStorage.getItem("list_direcciones")))
        // let incluirTransporte = JSON.parse(localStorage.getItem("incluye_transporte"))
        // let tipoEntrega       = JSON.parse(localStorage.getItem("tipoEntrega"))
        // let _this             = this
        // console.log('direcciones')
        // console.log(listaDirecciones)
        // console.log('statusPreventa')
        // console.log(_this.statusPreventa)
        // if(tipoEntrega == 'D'){
        //   _.remove(listaDirecciones, function(o) {
        //           return (o.id_tipo_direccion == '2'  && !_this.statusPreventa);
        //   });
        // }
        // else if(tipoEntrega == 'L'){
        //   _.remove(listaDirecciones, function(o) {
        //       return (o.id_tipo_direccion == '1'  && !_this.statusPreventa);
        //   });
        // }
        // else{

        // }
        // console.log('direcciones')
        // console.log(listaDirecciones)
        // return listaDirecciones;
      },
      esRetiraInstitucion(){
        return this.esTipoEntrega(1);
      },
      computadaTipoEntregaEnvio() {
        var tipoEntrega = this.selectTipoEntrega;
        if (!_.isEmpty(tipoEntrega)) {
          if (tipoEntrega.id_tipo_direccion != 1)
            return true;
          else
            return false;
        } else {
          this.clearForm();
          return false;
        }
      },
      computadaTipoEntrega() {
        var tipoEntrega = this.selectTipoEntrega;
        if (!_.isEmpty(tipoEntrega)) {
          if (tipoEntrega.id_tipo_direccion != 1)
            return true;
          else{
            this.clearForm();
            return false;
          }
        } else {
          this.clearForm();
          return false;
        }
      },
      validateFormCliente() {
        return this.email != '';
      },
      computadaCliente() {
        var cliente = this.selectCliente;
        if (_.isEmpty(cliente)) {
          this.clearFormCliente();
        } else {
          this.estado_numero_identificacion = true;
          this.cargaCliente(cliente);
        }
        return '';
      },
      validateForm() {
        return !this.errors.any() &&
          this.direccion != '' &&
         (_.isEmpty(this.pais)== true ) ? false : (_.size(this.pais.descripcion) == 0 ) ? false : true &&     
        (_.isEmpty(this.provincia)== true ) ? false : (_.size(this.provincia.descripcion) == 0 ) ? false : true &&     
        (_.isEmpty(this.canton)== true ) ? false : (_.size(this.canton.descripcion) == 0 ) ? false : true &&    
        (_.isEmpty(this.parroquia)== true ) ? false : (_.size(this.parroquia.descripcion) == 0 ) ? false : true;
        
      },
      
      detailFullName() {
        return this.fullName;
      },
      detailPhone() {
        return this.mobileNum;
      },
      subTotalConIva(){
        var carItem = this.$store.state.eCommerce.cartItems.slice().reverse();
        var listadoSubTotal =  _.groupBy(carItem, 'id_estudiante');
        this.data_general.listadoSubTotalConIva = [];

        var subTotalConIva = 0;
        _.forEach(listadoSubTotal,(estudiante)=>{
          var subTotalConIvaDentro = 0;
          _.forEach(estudiante, function (item) {
            if(item.est_iva == 'S'){
              subTotalConIvaDentro = _.round(item.total,4) + subTotalConIvaDentro;
            }
          });
          subTotalConIva = subTotalConIva + subTotalConIvaDentro;
          this.data_general.listadoSubTotalConIva.push(subTotalConIvaDentro)
        })

        return _.round(subTotalConIva,4);
      },
      subTotalSinIva(){
        var carItem = this.$store.state.eCommerce.cartItems.slice().reverse();
        var listadoSubTotal =  _.groupBy(carItem, 'id_estudiante');
        this.data_general.listadoSubTotalSinIva = [];

        var subTotalSinIvaDentro = 0;
        _.forEach(listadoSubTotal,(estudiante)=>{
          var subtotalSinIvaDentro = 0;
          _.forEach(estudiante, function (item) {
            if(item.est_iva != 'S'){
              subtotalSinIvaDentro = _.round(item.total,4) + subtotalSinIvaDentro;
            }
          });
          subTotalSinIvaDentro = subTotalSinIvaDentro + subtotalSinIvaDentro;
          this.data_general.listadoSubTotalSinIva.push(subtotalSinIvaDentro)
        })
        return _.round(subTotalSinIvaDentro,4);
      },
      subTotal() {
        var subtotalConIvaDentro = 0;
        var subtotalSinIvaDentro = 0;
        _.forEach(this.data_general.listadoSubTotalConIva, function (item) {
            subtotalConIvaDentro = _.round(item,4) + subtotalConIvaDentro;
        });

        _.forEach(this.data_general.listadoSubTotalSinIva, function (item) {
            subtotalSinIvaDentro = _.round(item,4) + subtotalSinIvaDentro;
        });

        return _.round(subtotalSinIvaDentro + subtotalSinIvaDentro,4);
        // var carItem = this.$store.state.eCommerce.cartItems.slice().reverse();
        // var subTotal = 0;
        // _.forEach(carItem, function (item) {
        //   console.log(item.subtotal);
        //   subTotal = _.round(_.round(item.subtotal,4) + subTotal,4);
        // });
        // // return subTotal.toFixed(2);
        // return _.round(subTotal,4);
      },
      subtotalDescuento(){
        var subtotal = this.subTotal;
        var descuento = this.descuento;
        // return (subtotal -descuento).toFixedtoFixed(2);
        return _.round(subtotal - descuento,4);
      },
      descuento() {
        var carItem = this.$store.state.eCommerce.cartItems.slice().reverse();
        var descuento = 0;

        _.forEach(carItem, function(item) {
          // if(item.aplica_descuento == 'S'){
            //   item.valor_descuento = ( ( parseFloat(item.price) * parseFloat(item.quantity)) * item.porcentaje_descuento ) / 100 ;
          //   // descuento = (item.subtotal - item.total) + descuento;
          // }
          descuento = _.round(item.valor_descuento,4) + descuento;
        });
        // return descuento.toFixed(2);
        return descuento;
      },
      impuesto() {
        _.forEach(this.data_general.listadoSubTotalConIva, (producto)=>{
          var impuesto = (producto * localStorage.getItem("iva"))/100;
          this.data_general.listadoIva.push(impuesto);
        })
        var subTotalConIva = this.subTotalConIva;
        var impuesto = (subTotalConIva * localStorage.getItem("iva"))/100;
        return (Math.round(impuesto * 100) / 100);

      },
      envio() {
        var cartItem   = this.$store.state.eCommerce.cartItems.slice().reverse();
        var students   = _.uniqBy(cartItem, 'id_estudiante');
        var transporte = 0;
        return 0;
        // if(!this.computadaTipoEntrega){
        //   return transporte;
        // }else{
        //   return _.size(students) * valueTrans;
        // }
      },
      total() {
        var subTotalSinIva = 0;
        var subTotalConIva = 0;
        var iva = 0;
        subTotalConIva = _.round(_.sum(this.data_general.listadoSubTotalConIva),4);
        subTotalSinIva = _.round(_.sum(this.data_general.listadoSubTotalSinIva),4);
        iva            = this.impuesto

        //  let subTotalConIva = this.subTotalConIva;

         let total = 0;
         total = _.round(subTotalConIva,4) + _.round(iva,4) + _.round(subTotalSinIva,4)  ;
        return _.round(total,2);
      },
      cantidadVender() {
        return _.size(this.$store.state.eCommerce.cartItems.slice().reverse());
      },
      cartItems() {
        return this.$store.state.eCommerce.cartItems.slice().reverse();
      },
      isInWishList() {
        return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
      },

    },
    methods: {
      incluirTransporte(incluir) {
        if (typeof incluir !== 'boolean') throw new Error("El parámetro debe ser booleano");

        const ID_DATA_INCLUYE_TRANSPORTE = 'incluye_transporte';

        const AGREGAR_SERVICIO_TRANSPORTE = 'S';
        const QUITAR_SERVICIO_TRANSPORTE = 'N';

        const agregar = incluir ? AGREGAR_SERVICIO_TRANSPORTE : QUITAR_SERVICIO_TRANSPORTE;
        localStorage.setItem(ID_DATA_INCLUYE_TRANSPORTE, JSON.stringify(agregar));
      },
      esTipoEntrega(tipo){
        const tipoEntrega = this.selectTipoEntrega;
        if (null == tipoEntrega) {
          return false;
        }
        return tipoEntrega.id_tipo_direccion == tipo;
      },
      esEntregaDomicilio() {
        return this.esTipoEntrega(2);
      },
      computadaDireccion() {
        var direccion = this.selectDireccion;
        if (_.isEmpty(direccion)) {
          this.clearForm();
        } else {
          this.cargaDireccion(direccion);
        }
        return '';
      },
      paisesRest(clean=true){
            if(clean)this.form.id_pais="";
            var q="paises";
            this.$vs.loading();
            return this.$http.get(this.$store.state.domain+`mapgrafi/division-geografica/paises`)
            .then((response) => {
              this.$vs.loading.close(); 
              this.selects[q] = response.data.data;
              return this.changePais(clean);

            })
            .catch((error)=>{
              this.$vs.loading.close(); 
            });
          },
        provinciasRest(clean=true){
          if(clean)this.form.id_pais="";
          var q="provincias";
          if(_.size(this.pais.descripcion))
          return this.$http.get(this.$store.state.domain+`mapgrafi/division-geografica/pais/${this.pais.valor}/provincias`)
              .then((response) => {
                this.$vs.loading.close(); 
                this.selects[q] = response.data.data;
                return this.changeProvincia(clean);
              })
              .catch((error)=>{
                this.$vs.loading.close(); 
              });
        },
        ciudadesRest(clean=true){
          if(clean){
            this.form.id_ciudad="";
            this.form.id_barrio="";
          }
          var q="ciudades";
          if(_.size(this.pais.descripcion) && _.size(this.provincia.descripcion))
          return this.$http.get(this.$store.state.domain+`mapgrafi/division-geografica/pais/${this.pais.valor}/provincia/${this.provincia.valor}/cantones`)
              .then((response) => {
                this.$vs.loading.close(); 
                this.selects[q] = response.data.data;
                return this.changeCiudad(clean);
              })
              .catch((error)=>{
                this.$vs.loading.close(); 
              });
        },
        barriosRest(clean=true){
          if(clean)this.form.id_barrio="";
          var q="barrios";
          if((_.size(this.pais.descripcion) && _.size(this.provincia.descripcion)&& _.size(this.canton.descripcion)))
          return this.$http.get(this.$store.state.domain+`mapgrafi/division-geografica/pais/${this.pais.valor}/provincia/${this.provincia.valor}/canton/${this.canton.valor}/parroquias`)
              .then((response) => {
                this.$vs.loading.close(); 
                this.selects[q] = response.data.data;
              })
              .catch((error)=>{
                this.$vs.loading.close(); 
              });
        },
        changePais(clean=true){
          if(_.isEmpty(this.pais)){
            this.provincia={descripcion:'',valor:''};
            this.canton={descripcion:'',valor:''};
            this.pais={descripcion:'',valor:''};
            this.parroquia={descripcion:'',valor:''};
            this.selects.provincias=[];
            this.selects.barrios=[];
            this.selects.ciudades=[];
          }else{
            return Promise.all([
              this.provinciasRest(clean)
            ]).then((values)=>{

            });
          }
        },
        changeProvincia(clean=true){
          if(_.isEmpty(this.provincia)){
            this.provincia={descripcion:'',valor:''};
            this.canton={descripcion:'',valor:''};
            this.parroquia={descripcion:'',valor:''};
            this.selects.ciudades=[];
            this.selects.barrios=[];
          }else{
            return Promise.all([
            this.ciudadesRest(clean)
            ]).then((values)=>{
              // console.log("se cambio la provincia");
            });
          }
        },
        changeCiudad(clean=true){
          if(_.isEmpty(this.canton)){
            this.canton={descripcion:'',valor:''};
            this.parroquia={descripcion:'',valor:''};
            this.selects.barrios=[];
          }else{
            return Promise.all([
              this.barriosRest(clean)
            ]).then((values)=>{
              // console.log("se cambio la ciudad");
            });
          }
      },
      // TAB 1
      removeItemFromCart(item) {
        // var incluirTransporte = JSON.parse(localStorage.getItem("incluye_transporte"));
        var transporte = JSON.parse(localStorage.getItem("transporte"));
        // if (incluirTransporte == 'S'){
        //     if (transporte.objectID == item.objectID && transporte.cod_clasificacion == item.cod_clasificacion) {
        //             this.popupCorrectOrder = true;
        //             this.mensaje           = 'Producto obligatorio, no puede eliminarlo';
        //     } else{
        //       this.$store.dispatch('eCommerce/toggleItemInCart', item)
        //     }
        // }
        // else {
              this.$store.dispatch('eCommerce/toggleItemInCart', item)
        // }
      },
      updateItemQuantity(event, index) {
        const itemIndex = Math.abs(index + 1 - this.cartItems.length)
        this.$store.dispatch("eCommerce/updateItemQuantity", {
          quantity: event,
          index: itemIndex
        })
      },

      // TAB 2
      habilitarDireccion() {
        var direccion = this.selectDireccion;
        if (_.isEmpty(direccion)) {
          this.clearForm();
          this.desBlockInput();
        } else {
          this.clearForm();
        }
      },
      cargaDireccion(direccion) {
        this.desBlockInput();
        this.pais={descripcion:'',valor:''};
        this.provincia={descripcion:'',valor:''};
        this.canton={descripcion:'',valor:''};
        this.parroquia={descripcion:'',valor:''};
        
        this.telefono              = direccion.telefono;
        this.celular               = direccion.celular;
        this.direccion             = direccion.direccion;
        this.referencia            = direccion.referencia;
        this.id_direccion          = direccion.id_direccion;
        this.pais.descripcion      = direccion.pais;
        this.provincia.descripcion = direccion.provincia;
        this.canton.descripcion    = direccion.canton;
        this.parroquia.descripcion = direccion.parroquia;
        this.cod_persona		   = direccion.cod_persona;
        this.pais.valor	           = direccion.id_pais;
        this.provincia.valor	   = direccion.id_provincia;
        this.canton.valor	       = direccion.id_canton;
        this.parroquia.valor	   = direccion.id_parroquia;
        this.changePais(false);
      },
      blockInput() {
        this.estado_telefono = true;
        this.estado_celular = true;
        this.estado_direccion = true;
        this.estado_referencia = true;
        this.estado_pais = true;
        this.estado_provincia = true;
        this.estado_canton = true;
        this.estado_parroquia = true;
      },
      desBlockInput() {
        this.estado_telefono = false;
        this.estado_celular = false;
        this.estado_direccion = false;
        this.estado_referencia = false;
        this.estado_pais = false;
        this.estado_provincia = false;
        this.estado_canton = false;
        this.estado_parroquia = false;
      },
      clearForm() {
        this.blockInput();
        this.selectDireccion=null;
        this.id_direccion='';
        this.telefono='';
        this.celular='';
        this.direccion='';
        this.referencia='';
        this.pais={descripcion:'',valor:''};
        this.provincia={descripcion:'',valor:''};
        this.canton={descripcion:'',valor:''};
        this.parroquia={descripcion:'',valor:''};
        this.cod_persona='';
        this.selects.provincias=[];
        this.selects.ciudades=[];
        this.selects.barrios=[];
      },
      cargaGeneral() {
        this.cargaGeneralTipoDireccion();
        this.$vs.loading();
        this.clearForm();
        this.id_usuario = this.$store.state.AppActiveUser.id_usuario;
        this.$http.post(this.$store.state.domain+`mapgrafi/direccion/direccion-carga-general`, {
            id_usuario: this.$store.state.AppActiveUser.id_usuario, // id_usuario
            estado: 'A',
            cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
          })
          .then((response) => {
            this.$vs.loading.close();

            if (response.status != 200) throw 'SERVIDOR NO RESPONDE';
            else if (response.data.existeError) throw response.data.mensaje;
            else {
              this.listaDirecciones = response.data.data;
              this.cargaDataClienteRetiraInstitucion();
            }
          })
          .catch(error => {
            this.$vs.loading.close();
            this.popupCorrectOrder = true;
            this.mensaje           = error;
          })
      },
      insertarActualizar() {
        var direccion = this.selectDireccion;

        this.$vs.loading();
        this.$http.post(this.$store.state.domain+`mapgrafi/direccion/direccion-insertar-actualizar`, {
            evento: (direccion == null) ? 'I' : 'U',
            id_usuario: this.id_usuario,
            id_direccion: this.id_direccion,
            telefono: this.telefono,
            celular: this.celular,
            direccion: this.direccion,
            referencia: this.referencia,
            pais                       : this.pais.descripcion,
            provincia                  : this.provincia.descripcion,
            canton                     : this.canton.descripcion,
            parroquia                  : this.parroquia.descripcion,
            id_pais                    : this.pais.valor,
            id_provincia               : this.provincia.valor,
            id_canton                  : this.canton.valor,
            id_parroquia               : this.parroquia.valor,
            estado: 'A',
            cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
          })
          .then((response) => {
            this.$vs.loading.close();
            if (response.status != 200) throw 'SERVIDOR NO RESPONDE';
            else if (response.data.existeError) throw response.data.mensaje;
            else {
              this.cargaGeneral();
              this.popupCorrectOrder = true;
              this.mensaje           = response.data.mensaje;
            }
          })
          .catch(error => {
            this.$vs.loading.close();
            this.popupCorrectOrder = true;
            this.mensaje           = error;
          })
      },
      limpiarEspacios(campo) {
        if (this.formRetiraInst[campo]) {
          this.formRetiraInst[campo] = this.formRetiraInst[campo].trim();
        }
      },
      async valForm(){
        if (this.esRetiraInstitucion) {
          return await this.valInfoRetiroInst();
        }
        // aqui deberia ir una validacion por domicilio
        return true;
      },
      async valValidate(scope){
        const cumple = await this.$validator.validateAll(scope); // Posible mejora agregar un popup indicando la valdiacion.
        return cumple;
      },
      async valInfoRetiroInst(){
        return await this.valValidate('info-retiro-inst');
      },
      submitNewAddressForm() {
        return new Promise(() => {
          this.$validator.validateAll('add-new-address').then(result => {
            if (true) {
              // if (result) {
              // if form have no errors
              this.$refs.checkoutWizard.nextTab();
            } else {
              this.popupCorrectOrder = true;
              this.mensaje           = 'Por favor, ingrese todos los campos';
            }
          })
        })
      },

      // TAB 3


      // TAB 3 - DATOS DEL CLIENTE
      cargaCliente(cliente) {
        this.desblockInputCliente();
        this.email = cliente.email;
        this.telefonoCliente = cliente.telefono;
        this.celularCliente = cliente.celular;
        this.cod_persona = cliente.cod_persona;
        this.id_usuario = cliente.id_usuario;
        this.id_usuario_cliente = cliente.id_usuario_cliente;
        this.numero_identificacion = cliente.numero_identificacion;
        this.apellidos = cliente.apellidos;
        this.nombres_cliente = cliente.nombres;
        this.email = cliente.email;
        this.cod_cliente = cliente.cod_cliente;
      },
      blockInputCliente() {
        this.estado_numero_identificacion = true;
        this.estado_email = true;
        this.estado_nombres = true;
        this.estado_apellidos = true;
        this.estado_telefonoCliente = true;
        this.estado_celularCliente = true;
      },
      desblockInputCliente() {
        this.estado_email = false;
        this.estado_telefonoCliente = false;
        this.estado_celularCliente = false;
      },
      clearFormCliente() {
        this.blockInputCliente();
        this.id_usuario_cliente = null;
        this.cod_cliente = null;
        this.selectCliente = null;
        this.estado_numero_identificacion = false;
        this.email = '';
        this.nombres_cliente = '';
        this.apellidos = '';
        this.numero_identificacion = '';
        this.telefonoCliente = '';
        this.celularCliente = '';
        this.cod_persona = '';
        this.id_usuario_cliente = null;
      },
      searchIdentificationNumber() {
        if (_.size(this.numero_identificacion) != 0 && this.numero_identificacion != null) {
          this.$vs.loading();
          this.$http.post(this.$store.state.domain+`mapgrafi/cliente/cliente-carga-general`, {
              evento: "L1",
              id_usuario: this.$store.state.AppActiveUser.id_usuario,
              numero_identificacion: (this.numero_identificacion),
              cod_persona: null,
              estado: "A",
							cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
            })
            .then((response) => {
              this.$vs.loading.close();
              if (response.status != 200) throw 'SERVIDOR NO RESPONDE';
              else if (response.data.existeError) {
                this.popupCorrectOrder = true;
                this.mensaje           = response.data.mensaje;
              } else {
                if (_.size(response.data.data) == 0) {
                  this.popupCorrectOrder = true;
                  this.mensaje           = 'Número de Identificación incorrecta / Ingrese un cliente.';
                } else {
                  this.desblockInputCliente();
                  this.insertDataConsultCliente(response.data.data[0]);
                }
              }
            })
          .catch(error => {
            this.$vs.loading.close();
            this.popupCorrectOrder = true;
            this.mensaje           = error;
          })
        } else {
            this.popupCorrectOrder = true;
            this.mensaje           = 'Ingrese número de Identificación';
        }
      },
      cargaGeneralTipoDireccion(){
          this.$http.get(this.$store.state.domain+`mapgrafi/mapgrafi-general/tipo-direccion-carga-general/${process.env.VUE_APP_COD_EMPRESA_ERP}`)
            .then((response) => {   
            			if(response.status != 200) throw 'SERVIDOR NO RESPONDE';
                  else if (response.data.existeError) throw response.data.mensaje;
                  else{
                    localStorage.setItem('list_direcciones',JSON.stringify(response.data.data));
                  }  
            })
            .catch(error=>{
              this.$vs.loading.close(); 
              this.popupCorrectOrder = true;
              this.mensaje           = error;
            })
      },
      async puedeIrPestanaPago(){
        return await this.valForm();
      },
      async cargaGeneralCliente() {
        const vForm = await this.valForm();
        if (!vForm) {
          return;
        }
        this.$vs.loading();
        this.$http.post(this.$store.state.domain+`mapgrafi/cliente/cliente-carga-general`, {
            evento: "L1",
            id_usuario: this.$store.state.AppActiveUser.id_usuario,
            numero_identificacion: null,
            cod_persona: null,
            estado: "A",
            cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
          })
          .then((response) => {
            this.$vs.loading.close();
            if (response.status != 200) throw 'SERVIDOR NO RESPONDE';
            else if (response.data.existeError) {
              this.popupCorrectOrder = true;
              this.mensaje           = response.data.mensaje;
            } else {
              if (_.size(response.data.data) == 0) {
                this.popupCorrectOrder = true;
                this.mensaje           = 'Número de Identificación incorrecta / Ingrese un cliente.';
              } else {
                // this.desblockInputCliente();
                this.listaClientes = response.data.data;
                this.$refs.checkoutWizard.nextTab();
              }
            }
          })
          .catch(error => {
            this.$vs.loading.close();
            this.popupCorrectOrder = true;
            this.mensaje           = error;
          })
      },
      insertarActualizarCliente() {
        var cliente = this.selectCliente;

        this.$vs.loading();
        this.$http.post(this.$store.state.domain+`mapgrafi/cliente/cliente-insertar-actualizar`, {
            evento: (_.isEmpty(this.id_usuario_cliente)) ? 'I' : 'U',
            id_usuario_cliente: this.id_usuario_cliente,
            id_usuario: this.$store.state.AppActiveUser.id_usuario,
            cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
            id_direccion: this.id_direccion,
            telefono: this.telefonoCliente,
            celular: this.celularCliente,
            nombres: this.nombres_cliente,
            apellidos: this.apellidos,
            numero_identificacion: this.numero_identificacion,
            email: this.email,
            cod_persona: this.cod_persona,
            cod_cliente: this.cod_cliente,
            estado: 'A'
          })
          .then((response) => {
            this.$vs.loading.close();
            if (response.status != 200) throw 'SERVIDOR NO RESPONDE';
            else if (response.data.existeError) throw response.data.mensaje;
            else {
              this.popupCorrectOrder = true;
              this.mensaje           = response.data.mensaje;
              this.cargaGeneralCliente();
              this.clearFormCliente();
            }
          })
          .catch(error => {
            this.$vs.loading.close();
            this.popupCorrectOrder = true;
            this.mensaje           = error;
          })
      },
      validatorOnlineCliente() {
        if (!this.$store.state.AppActiveUser.status)
          this.$router.push('/');
        else {
          // this.cargaGeneralCliente();
        }
      },
      insertDataConsultCliente(user) {
        this.email = user.email;
        this.nombres_cliente = user.nombres;
        this.apellidos = user.apellidos;
        this.numero_identificacion = user.numero_identificacion;
        this.telefonoCliente = user.telefono;
        this.celularCliente = user.celular;
        this.cod_persona = user.cod_persona;
        this.cod_cliente = user.cod_cliente;
      },

      // TAB 3 - FIN DE DATOS DEL CLIENTE
      manejadorGenerarComprobante() {
        if (this.selectFacturaPago.value == 2 || this.selectFacturaPago.value == 3 ){
          this.abrirPasarela();
        }
        else if (this.selectFacturaPago.value == 1){
            this.responseBoton = JSON.stringify("");
            this.authorization_code = null;
            this.transaction_id = null
            this.order_reference = null;
            this.generarComprobante("");
        }
      },
      generarComprobante(respuestaBotonPago){
        try {
          let _this = this
          _this.responseBoton = JSON.stringify(respuestaBotonPago);
          _this.authorization_code = (respuestaBotonPago == '' ) ? '' : respuestaBotonPago.transaction.authorization_code;
          _this.transaction_id = (respuestaBotonPago == '') ? '' : respuestaBotonPago.card.transaction_reference;
          _this.$vs.loading();
  
          axios.post(_this.$store.state.domain+`mapgrafi/ordenes-compra/ordenes-compra-generar`,{
              evento: 'I',
              cod_empresa: null,
              anio: null,
              valor_impuesto  : JSON.parse(localStorage.getItem('iva')),
              nombre_facturado:_this.apellidos+' '+_this.nombres_cliente,
              id_usuario: _this.$store.state.AppActiveUser.id_usuario,
              id_usuario_cliente: _this.id_usuario_cliente,
              id_usuario_direccion: _this.id_direccion,
              id_proforma_mu: null,
              email: _this.email,
              nombres_facturado: _this.nombres_facturado,
              numero_identificacion: _this.numero_identificacion,
              tipo_pago: _this.selectFacturaPago.text,
              id_forma_pago: _this.selectFacturaPago.value,
              tipo_entrega: _this.getLugarEntrega(),
              entrega: _this.getDatosEntrega(),
              tipo_entrega_id: _this.selectTipoEntrega.id_tipo_direccion,
              cod_cliente:_this.selectCliente.cod_cliente,
              subTotalConIva:_this.subTotalConIva,
              subTotalSinIva:_this.subTotalSinIva,
              subtotal: _this.subTotal,
              descuento: _this.descuento,
              iva: _this.impuesto,
              transporte: _this.envio,
              total: _this.total,
              detalle: (_.isEmpty(localStorage.carItems)) ? null : (JSON.parse(localStorage.carItems)),
              aceptoTerminoCondiciones: _this.aceptoTerminoCondiciones,
              responseBoton : _this.responseBoton ,
              authorization_code : _this.authorization_code ,
              transaction_id : _this.transaction_id ,
              order_reference: _this.order_reference,
              cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
              estado: 'A'
            })
            .then((response) => {
              _this.$vs.loading.close();
              if (response.status != 200) throw response.status;
                if(response.data.existeError) throw response.data.mensaje;
                  else{
                    _this.popupCorrectOrderCompra = true;
                    _this.mensaje = response.data.mensaje+' Su número de órden es: '+response.data.data.proforma;
                    _this.mensajeLeyenda = response.data.data.mensajeLeyenda;
                    
                    axios.post(_this.$store.state.domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`,{
                      evento    : "DELETE",
                      id_usuario: _this.activeUserInfo.id_usuario,
                      carrito   : null,
                      cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
                    })
                    _this.data_general.listadoSubTotalSinIva = [];
                    _this.data_general.listadoSubTotalConIva = [];
                    _this.data_general.listadoIva            = [];
                    _this.data_general.listadoTotal          = [];
  
                    _this.$store.dispatch('eCommerce/deleteItems')
                    _this.clearFormCliente();
                    _this.clearForm();
                  }
            })
            .catch(error => {
              _this.$vs.loading.close();
              _this.popupErrorOrder = true;
              _this.mensaje = 'Error, vuelva a generar la órden.';
            })
        } catch (error) {
        }
      },
      getLugarEntrega(){
        if (this.esRetiraInstitucion) {
          return this.selectTipoEntrega.descripcion;
        } else {
          return (this.selectDireccion.direccion+'§'+this.selectDireccion.referencia+'§'+this.selectDireccion.telefono+'§'+this.selectDireccion.celular);
        }
      },
      getDatosEntrega(){    
        if (this.esRetiraInstitucion) {
          const info = this.formRetiraInst;
          return `${info.nombre} ${info.celular}`;
        } else {
          return (this.selectDireccion.direccion+'§'+this.selectDireccion.referencia+'§'+this.selectDireccion.telefono+'§'+this.selectDireccion.celular);
        }
      },
      cargaDataClienteRetiraInstitucion(){
        const infoUser = this.$store.state.AppActiveUser;
        const nombreUserLogin = `${infoUser.apellidos} ${infoUser.nombres}`;
        this.formRetiraInst.celular = infoUser.celular;
        this.formRetiraInst.nombre = nombreUserLogin;
      },
      validateProductoTransporte(){
        var  incluye_transporte =   JSON.parse(localStorage.getItem('incluye_transporte'));
        if(incluye_transporte == 'S'){
          var  transporte =   JSON.parse(localStorage.getItem('transporte'));
          var carItem = this.$store.state.eCommerce.cartItems.slice().reverse();
          carItem = _.groupBy(carItem,'id_estudiante');
          var _this = this;
          _.forEach(carItem, function (item) {
            var transporteExistente = _.find(item, function(o) { return o.cod_clasificacion == transporte.cod_clasificacion &&  o.cod_fabrica == transporte.cod_fabrica; });
            if(_.isEmpty(transporteExistente)){
              transporte.id_estudiante = item[0].student.id_estudiante;
              transporte.student = _.clone(item[0].student);
              _this.$store.dispatch('eCommerce/additemInCart', transporte)
              _this.$http.post(_this.$store.state.domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`,{
                          evento    : "GUARDAR",
                          id_usuario: this.activeUserInfo.id_usuario,
                          carrito   : (localStorage.getItem('carItems')),
                          cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
              })
              .then((response) => {
                  this.$vs.loading.close(); 
              })
              .catch(() => {
                  this.$vs.loading.close(); 
              });

            }
          });
          // this.validarTransporte()
        }
      },
      validarTransporte(){
        // var  incluye_transporte =   JSON.parse(localStorage.getItem('incluye_transporte'));
        // if(incluye_transporte == 'S'){
        //   var  transporte =   JSON.parse(localStorage.getItem('transporte'));
        //   var carItem = this.$store.state.eCommerce.cartItems.slice().reverse();
        //   carItem = _.groupBy(carItem,'id_estudiante');
        //   var _this = this;
        //   _.forEach(carItem, function (item,key ) {
        //     if(_.size(item) == 1){
        //         _this.$store.dispatch('eCommerce/toggleItemInCart', item[0])
        //       // _this.removeItemFromCart(item[0])
        //     }
        //     // var transporteExistente = _.find(item, function(o) { return o.cod_clasificacion == transporte.cod_clasificacion &&  o.cod_fabrica == transporte.cod_fabrica; });
        //     // if(_.isEmpty(transporteExistente)){
        //     //   transporte.id_estudiante = item[0].student.id_estudiante;
        //     //   transporte.student = _.clone(item[0].student);
        //     //   _this.$store.dispatch('eCommerce/additemInCart', transporte)
        //       // _this.$http.post(_this.$store.state.domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`,{
        //       //             evento    : "GUARDAR",
        //       //             id_usuario: this.activeUserInfo.id_usuario,
        //       //             carrito   : (localStorage.getItem('carItems')),
        //       //             cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
        //       // })
        //       // .then((response) => {
        //       //     this.$vs.loading.close(); 
        //       // })
        //       // .catch(() => {
        //       //     this.$vs.loading.close(); 
        //       // });

        //     // }
        //   });
        // }
      },
      validatePreventa(){
        var  fecha_preventa =   JSON.parse(localStorage.getItem('date_pre_sale'));
        var statusPreventa;
        let pro = new Promise((resolve, reject) => {
            axios.get(this.$store.state.domain+`mapgrafi/mapgrafi-general/obtener-fecha`)
            .then((response) => {
              resolve(response);
            })
        });
        pro.then((response) => {
          // aqui puedo validar lo de preventa
          statusPreventa  = moment(response.data).isBetween(fecha_preventa.fechaDesde, fecha_preventa.fechaHasta, null, '[]'); //truereturn true
          localStorage.removeItem('statusPreventa');
          localStorage.setItem('statusPreventa',JSON.stringify(statusPreventa));
        });

      },
      //#region Pasarela pago

      //#region inicializacion

      initPasarelaPago(){
        const _this = this;
        return new PaymentCheckout.modal({
          env_mode: process.env.VUE_APP_AMBIENTE,
          onOpen: function () {

          },
          onClose: function () {
            if (null !== _this.order_reference) {
              _this.cerrarPasarelaModal();
            }
          },
          onResponse: function (response) { 
            _this.realizarPagoPasarela(response);
          }
        });
      },
     
      configurarEventosPasarela(){
        const _this=this;
        window.addEventListener('popstate', function () {
          if (!_this.pasarelaAbierta()) {
            return;
          }
          _this.paymentCheckout.close();
        });
        window.addEventListener('beforeunload', function (e) {
          if (!_this.pasarelaAbierta()) {
            return;
          }
          e.preventDefault();
          _this.cerrarPasarelaModal();
          _this.paymentCheckout.close();
        });
      },

      //#endregion

      //#region Logica
      async abrirPasarela(){
        this.order_reference = null;
        this.pasarela = null;
        const respuesta = await this.getSesionPasarela();
 
        if (null !== respuesta) {
          this.order_reference = respuesta.dev_reference;
          this.pasarela = respuesta.pasarela;
          const confi = this.getConfiBtnPagoOpen(respuesta);
  
          this.paymentCheckout.open(confi);
        }
      },

      realizarPagoPasarela(response){
        this.order_reference = null;
        if (typeof response !== 'object' || response === null) {
          console.error("Respuesta inválida:", response);
          alert("Respuesta inválida del sistema de pagos");
          return;
        }

        const hasProp = (obj, prop) =>
          Object.prototype.hasOwnProperty.call(obj, prop);

        if (hasProp(response, 'error')) {
          const error = response.error;
          if (typeof error !== 'object' || error === null) {
            console.error("Estructura de error inválida:", error);
            alert("Error inesperado en el sistema de pagos");
            return;
          }

          const description = hasProp(error, 'description')
            ? error.description
            : "Error desconocido en el pago";

          console.error("Error en checkout:", error);
          alert(description);
          return;
        }

        const _this = this;
        const rutaBase = this.$store.state.domain;
        axios.post(rutaBase+`mapgrafi/mapgrafi-general/save-respuesta-pasarela-pago/nuvei/interno`, response)
        .then(response => {
          const {existeError, mensaje, data} = response.data;
          if (existeError) {
            throw mensaje;
          }
          const {estadoTransaccion} = data;
          if (estadoTransaccion) {
            this.popupCorrectOrderCompra = true;
            this.mensaje = estadoTransaccion;
            this.mensajeLeyenda = "";
            
            
          }else{
            const {proforma, mensajeLeyenda} = data;
            if (proforma && mensajeLeyenda) {
              this.compraExitosa(data);
            }   
          }  
        })
        .catch(error => {
          this.$vs.loading.close();
          this.popupCorrectOrder = true;
          this.mensaje = error;
        })
      },

       compraExitosa(data){
        this.popupCorrectOrderCompra = true;
        this.mensaje = ' Su número de órden es: '+data.proforma;
        this.mensajeLeyenda = data.mensajeLeyenda;
        
        axios.post(this.$store.state.domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`,{
          evento    : "DELETE",
          id_usuario: this.activeUserInfo.id_usuario,
          carrito   : null,
          cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
        })
        this.data_general.listadoSubTotalSinIva = [];
        this.data_general.listadoSubTotalConIva = [];
        this.data_general.listadoIva            = [];
        this.data_general.listadoTotal          = [];

        this.$store.dispatch('eCommerce/deleteItems')
        this.clearFormCliente();
        this.clearForm();
      },
      //#endregion

      //#region obtecion de datos

       //#region Peticiones
      async getSesionPasarela(){
        const data = this.getDataCompra();
        const rutaBase = this.$store.state.domain;
        const url = rutaBase+`mapgrafi/mapgrafi-general/obtener-sesion-pasarela`;
        this.$vs.loading();
        return await axios.post(url, data)
        .then(response => {
          const {existeError, mensaje, data} = response.data;

          if(existeError) throw mensaje;

          return data;
        })
        .catch(error => {
          this.popupCorrectOrder = true;
          this.mensaje = error;
          return null;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
      }, 
      dataParaCerrarModal() {
        return {
          pasarela: this.pasarela,
          dev_reference: this.order_reference,
        };
      },
      dataUrlCerrarModal() {
        const rutaBase = this.$store.state.domain;
        const url = rutaBase+`mapgrafi/mapgrafi-general/cerrar-sesion-pasarela`;
        return url;
      },
      pasarelaAbierta() {
        const data = this.dataParaCerrarModal();

        const { pasarela, dev_reference } = data;

        if (typeof pasarela !== 'string' || pasarela.trim() === '') {
          return false;
        }

        const type = typeof dev_reference;
        if (dev_reference === null || type === 'object' || dev_reference === '') {
          return false;
        }

        return true;
      },
      async cerrarPasarelaModal(){
        const data =this.dataParaCerrarModal();
        if (!this.pasarelaAbierta()) {
          return;
        }
        const url =this.dataUrlCerrarModal();
        this.$vs.loading();
        return await axios.post(url, data)
        .then(response => {
          const {existeError, mensaje, data} = response.data;

          if(existeError) throw mensaje;

          return data;
        })
        .catch(error => {
          this.popupCorrectOrder = true;
          this.mensaje = error;
          return null;
        })
        .finally(() => {
          this.order_reference = null;
          this.pasarela = null;
          this.$vs.loading.close();
        });
      },
      //#endregion
      getConfiBtnPagoOpen(data){
        return {
            reference: data.reference
          };
      },

      getDataCompra(){
        const dataCompartida = this.getDataCompartida();
        const dataParaPasarela = this.getDataParaPasarela(dataCompartida);
        const dataParaOrden = this.getDataParaComprobante(dataCompartida);
        dataParaPasarela.dataParaOrden = dataParaOrden;
        return dataParaPasarela;
      },
      getDataParaPasarela(dataCompartida){
        const dataBase = {
          cod_empresa: dataCompartida.codEmpresa,
          id_usuario: dataCompartida.idUser,
          carrito   : dataCompartida.carrito,
          response_pasarela_pago: null,
          request_pasarela_pago: null,
          pasarela: 'nuvei',//Nuevo mio
        };

        const baseRequestPasarelaPago = {
          user: {
            id: dataCompartida.idUser,
            email: dataCompartida.email,
            user_phone: this.celularCliente,
          },
          order:{
            description: 'Compra mapgrafi.',
            amount: dataCompartida.total,
            vat: dataCompartida.impuesto,
            tax_percentage: dataCompartida.valorImpuesto,
            taxable_amount: _.round(this.subTotalConIva,2),
          },
        };

        if (this.selectFacturaPago.value == 3 ) {
          baseRequestPasarelaPago.order.installments_type = 2;//esto es un dato adicional no necesario parece, pero preguntar
        }

        dataBase.request_pasarela_pago = JSON.stringify(baseRequestPasarelaPago);
        return dataBase;
      },

      getDataCompartida(){
        const impuesto =this.impuesto;
        const valorImpuesto = impuesto == 0 ? 0 : JSON.parse(localStorage.getItem('iva'));
        return {
          codEmpresa: process.env.VUE_APP_COD_EMPRESA_ERP,
          idUser: this.activeUserInfo.id_usuario,
          carrito: (localStorage.getItem('carItems')),

           impuesto: this.impuesto,
           valorImpuesto: valorImpuesto,
           total:this.total,

           email: this.email,
        };
      },

      getDataParaComprobante(data){
        const dataCompartida = data;
        const dataCompra = this.getDatosCompra(dataCompartida);
        
        return {
          cod_empresa: dataCompartida.codEmpresa,//
          //info usuario
          id_usuario: dataCompartida.idUser,
          id_usuario_cliente: this.id_usuario_cliente,
          id_usuario_direccion: this.id_direccion,
          nombre_facturado: this.getNombresCliente(),
          email: dataCompartida.email,//
          nombres_facturado: this.nombres_facturado,
          numero_identificacion: this.numero_identificacion,
          id_proforma_mu: null,
          cod_cliente: this.selectCliente.cod_cliente,
          //otros
          transporte: this.envio,
          //compra
          tipo_pago: dataCompra.tipoPago,
          id_forma_pago: dataCompra.idFormaPago,
          tipo_entrega: dataCompra.tipoEntrega,
          entrega: dataCompra.entrega,
          tipo_entrega_id: dataCompra.tipoEntregaId,
          subTotalConIva:dataCompra.subTotalConIva,
          subTotalSinIva:dataCompra.subTotalSinIva,
          subtotal: dataCompra.subtotal,
          descuento: dataCompra.descuento,
          iva: dataCompra.impuesto,
          total: dataCompra.total,
          detalle: JSON.parse(dataCompra.carrito) ,
          valor_impuesto  : dataCompra.valorImpuesto,
          aceptoTerminoCondiciones: this.aceptoTerminoCondiciones,
          //Pasarela
          responseBoton : null ,//interno
          authorization_code : null ,//interno
          transaction_id : null ,//interno
          order_reference: null,//interno
        };
      },

      getDatosCompra(data){
        const dataCompartida = data;
        return {
          subTotalConIva:this.subTotalConIva,
          subTotalSinIva:this.subTotalSinIva,
          subtotal: this.subTotal,
          descuento: this.descuento,
          valorImpuesto :dataCompartida.valorImpuesto,
          impuesto :dataCompartida.impuesto,
          total: dataCompartida.total,//
          carrito: dataCompartida.carrito,//

          tipoPago: this.selectFacturaPago.text,
          idFormaPago: this.selectFacturaPago.value,
          tipoEntrega: this.getLugarEntrega(),
          entrega: this.getDatosEntrega(),
          tipoEntregaId: this.selectTipoEntrega.id_tipo_direccion,
        };
      },
      //#endregion

      //#endregion

      //#region General

      getNombresCliente(){
        return `${this.apellidos} ${this.nombres_cliente}`;
      },
      //#endregion
    },
    components: {
      ItemListView,
      FormWizard,
      TabContent
    },
    created() {
      this.validatePreventa();
      // this.validateProductoTransporte();
      this.validatorOnlineCliente();
      return Promise.all([ this.paisesRest()])
      .then((values)=>{
      })
    },
  mounted() {
    this.configurarEventosPasarela();
  }
  }
  
</script>

<style lang="scss" scoped>
  #ecommerce-checkout-demo {
    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
    }

    .item-name {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      -webkit-line-clamp: 2;
    }

    .vue-form-wizard {
      ::v-deep .wizard-header {
        padding: 0;
      }
    }
  }
  textarea {
    overflow-y: scroll;
    height: 100px;
    resize: none;
  }
  .messagePerfect{
    font-size: 20px;
    font-weight: 400;
    text-transform: uppercase;
  }
</style>